import Date from '@components/Station/Date'
import DateTime from '@components/Station/DateTime'
import Time from '@components/Station/Time'

export default {
  Time,
  Date,
  DateTime,
}
